module.exports = __webpack_public_path__ + "img/sorry-en.b9ad775.png";